import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'; // ← YEH ADD KARO
import '../../assets/css/style1.css';
import { Link } from 'react-router-dom';
import Socialicon from '../../pages/PrivacyPolicy/Socialicon';
import logoImage from '../../assets/images/logo.jpeg';
import api from '../../services/api';

const Navbar = () => {
  // Check if user is logged in
  const isLoggedIn = localStorage.getItem('user') !== null;
  const user = isLoggedIn ? JSON.parse(localStorage.getItem('user')) : null;
  
  // State for dropdown visibility
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // =========================================
  // DYNAMIC SERVICES (auto-populated as services are published in the CMS)
  // Shown in the mega menu's second column, next to the static service pages.
  // =========================================
  const [dynamicServices, setDynamicServices] = useState([]);

  useEffect(() => {
    api.get('/services')
      .then((res) => setDynamicServices((res.data.data || []).slice(0, 10)))
      .catch(() => {}); // Non-critical - menu still renders without it
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <section className="header header--2">
      {/* Top Bar */}
      <div className="top_bar top--bar2 d-flex align-items-center bg-primary">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex topbar_content justify-content-between">
                 
                <div className="top_bar--info order-0 d-none d-lg-block align-self-center">
                  <ul style={{fontSize:'20px', marginRight: '0.5rem'}}>
                    <Socialicon />
                  </ul>
                </div>
                <p style={{color:'#fff', paddingTop:'15px'}}>support@businessmateworkflow.in</p>
<p style={{color:'#fff', paddingTop:'15px'}}>☏ +91 9319332918</p>
                <div className="top_bar--social">
                  <ul style={{ position: 'relative', listStyle: 'none' }}>
                    {isLoggedIn ? (
                      <>
                        {user && (
                          <li className="dropdown" style={{ position: 'relative' }}>
                            <button
                              className="nav-link dropdown-toggle"
                              style={{
                                background: 'none',
                                border: 'none',
                                color: '#fff',
                                fontSize: '20px',
                                cursor: 'pointer',
                              }}
                              onClick={(e) => {
                                e.currentTarget.nextSibling.classList.toggle('show');
                              }}
                            >
                              {user.name || user.email}
                            </button>

                            {/* Dropdown menu */}
                            <ul
                              className="dropdown-menu"
                              style={{
                                position: 'absolute',
                                right: 0,
                                top: '100%',
                                background: '#fff',
                                listStyle: 'none',
                                padding: '10px 0',
                                margin: 0,
                                borderRadius: '8px',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                display: 'none',
                                minWidth: '150px',
                              }}
                            >
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to="/admin/dashboard"
                                  style={{
                                    display: 'block',
                                    padding: '8px 16px',
                                    color: '#000',
                                    textDecoration: 'none',
                                  }}
                                  onClick={(e) => {
                                    e.currentTarget.parentNode.parentNode.classList.remove('show');
                                  }}
                                >
                                  Dashboard
                                </Link>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={handleLogout}
                                  style={{
                                    display: 'block',
                                    width: '100%',
                                    padding: '8px 16px',
                                    background: 'none',
                                    border: 'none',
                                    textAlign: 'left',
                                    color: '#000',
                                    cursor: 'pointer',
                                  }}
                                >
                                  Logout
                                </button>
                              </li>
                            </ul>
                          </li>
                        )}
                      </>
                    ) : (
                      <>
                        <li>
                          <Link className="nav-link" to="/login" style={{ fontSize: '20px' }}>
                            Login
                          </Link>
                        </li>
                        <li>
                          <Link className="nav-link" to="/register" style={{ fontSize: '20px' }}>
                            Register
                          </Link>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Menu Area */}
      <div className="menu_area menu1">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light bg-light px-0">
            <a className="navbar-brand order-sm-1 order-1" href="/">
              <img src={logoImage} style={{ height:'95px' }} alt="Dashboard" />
            </a>
         <button
  className="navbar-toggler"
  type="button"
  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
  aria-controls="navbarSupportedContent2"
  aria-expanded={isMobileMenuOpen}
  aria-label="Toggle navigation"
>
  <span className="la la-bars"></span>
</button>

            <div
  className={`navbar-collapse order-md-1 ${
    isMobileMenuOpen ? 'mobile-menu-open' : ''
  }`}
  id="navbarSupportedContent2"
>
              <ul className="navbar-nav m-auto">
                <li className="nav-item active">
                  <Link className="nav-link" to="/">Home</Link>
                </li>
                <li className="nav-item active">
                  <Link className="nav-link" to="/about">About us</Link>
                </li>
                
                {/* Services Dropdown Menu */}
                <li 
                  className="nav-item dropdown active"
                  onMouseEnter={() => setIsServicesDropdownOpen(true)}
                  onMouseLeave={() => setIsServicesDropdownOpen(false)}
                  style={{ position: 'relative' }}
                >
                  <Link 
                    className="nav-link" 
                    to="#"
                    style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '5px' 
                    }}
                  >
                    Services 
                    <FontAwesomeIcon 
                      icon={faCaretDown} 
                      style={{ 
                        fontSize: '14px',
                        transition: 'transform 0.3s ease',
                        transform: isServicesDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                      }} 
                    />
                  </Link>
                  
                  {/* Mega Menu - two columns: fixed service pages on the
                      left, CMS-published services (the list that used to
                      live in the footer) on the right */}
                  {isServicesDropdownOpen && (
                    <div
                      className="dropdown-menu show mega-menu"
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        background: '#fff',
                        padding: '20px 0',
                        margin: 0,
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        minWidth: '520px',
                        zIndex: 1000,
                        display: 'flex',
                        animation: 'fadeIn 0.2s ease-in-out'
                      }}
                    >
                      {/* Column 1 - Static service pages */}
                 

                      {/* Column 2 - Dynamic CMS services */}
<div style={{ flex: 1, padding: '0 10px' }}>
  <h6 style={{ padding: '0 20px', marginBottom: 10, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#94a3b8' }}>
    More Services
  </h6>
  <ul
    style={{
      listStyle: 'none',
      padding: 0,
      margin: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      columnGap: '10px',
    }}
  >
                          <li>
                        <Link 
                          className="dropdown-item" 
                          to="/skilled-employee-services"
                          style={{
                            display: 'block',
                            padding: '10px 20px',
                            color: '#333',
                            textDecoration: 'none',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f8f9fa';
                            e.target.style.paddingLeft = '25px';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.paddingLeft = '20px';
                          }}
                        >
                          Talent & Workforce
                        </Link>
                      </li>
    <li>
                        <Link 
                          className="dropdown-item" 
                          to="/third-party-business-services"
                          style={{
                            display: 'block',
                            padding: '10px 20px',
                            color: '#333',
                            textDecoration: 'none',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f8f9fa';
                            e.target.style.paddingLeft = '25px';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.paddingLeft = '20px';
                          }}
                        >
                          Professional Services
                        </Link>
                      </li>
                      <li>
                        <Link 
                          className="dropdown-item" 
                          to="/business-for-sale-buy"
                          style={{
                            display: 'block',
                            padding: '10px 20px',
                            color: '#333',
                            textDecoration: 'none',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f8f9fa';
                            e.target.style.paddingLeft = '25px';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.paddingLeft = '20px';
                          }}
                        >
                          Business Opportunities - Sell & Buy
                        </Link>
                      </li>
                      <li>
                        <Link 
                          className="dropdown-item" 
                          to="/business-partner-services"
                          style={{
                            display: 'block',
                            padding: '10px 20px',
                            color: '#333',
                            textDecoration: 'none',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f8f9fa';
                            e.target.style.paddingLeft = '25px';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.paddingLeft = '20px';
                          }}
                        >
                          Strategic Partner
                        </Link>
                      </li>

    {dynamicServices.length > 0 ? (
      dynamicServices.map((service) => (
        
        <li key={service.id}>
          <Link
            className="dropdown-item"
            to={`/${service.slug}`}
            style={{
              display: 'block',
              padding: '10px 20px',
              color: '#333',
              textDecoration: 'none',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f8f9fa';
              e.target.style.paddingLeft = '25px';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.paddingLeft = '20px';
            }}
          >
            {service.service_name}
          </Link>
        </li>
      ))
    ) : (
      <li style={{ gridColumn: '1 / -1' }}>
        <Link
          className="dropdown-item"
          to="/services"
          style={{ display: 'block', padding: '10px 20px', color: '#333', textDecoration: 'none' }}
        >
          View All Services
        </Link>
      </li>
    )}
    {dynamicServices.length > 0 && (
      <li style={{ gridColumn: '1 / -1' }}>
        <Link
          to="/services"
          style={{
            display: 'block',
            padding: '10px 20px',
            color: '#06b590',
            fontWeight: 600,
            textDecoration: 'none'
          }}
        >
          View All Services &rarr;
        </Link>
      </li>
    )}
  </ul>
</div>
                    </div>
                  )}
                </li>
                
                <li className="nav-item active">
                  <Link className="nav-link" to="/plan">Plan</Link>
                </li>
                <li className="nav-item active">
                  <Link className="nav-link" to="/video">Video</Link>
                </li>
                <li className="nav-item active">
                  <Link className="nav-link" to="/blog">Blog</Link>
                </li>
                <li className="nav-item active">
                  <Link className="nav-link" to="/faq">FAQ</Link>
                </li>
                <li className="nav-item active">
                  <Link className="nav-link" to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>

      {/* Add CSS animation for dropdown */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @media (max-width: 767px) {
          .mega-menu {
            position: static !important;
            min-width: 100% !important;
            flex-direction: column !important;
            box-shadow: none !important;
          }
          .mega-menu > div {
            border-right: none !important;
          }
        }
@media (max-width: 991px) {
  #navbarSupportedContent2 {
    display: none;
    width: 100%;
  }

  #navbarSupportedContent2.mobile-menu-open {
    display: block;
  }

  #navbarSupportedContent2 .navbar-nav {
    width: 100%;
    margin: 0 !important;
  }

  #navbarSupportedContent2 .nav-item {
    width: 100%;
  }

  #navbarSupportedContent2 .nav-link {
    display: block;
    padding: 12px 15px;
  }

  .navbar-toggler {
    display: block;
    border: none;
    background: transparent;
    font-size: 24px;
    cursor: pointer;
  }
}
      `}</style>
    </section>
  );
};

export default Navbar;